import React from 'react';
import {
    Award,
    ShieldCheck,
    CheckCircle2,
    Star,
    Clock,
    PhoneCall,
    MapPin,
} from 'lucide-react';
import './TopMarqueeStrip.css';

export const TOP_MARQUEE_ITEMS = [
    {
        icon: MapPin,
        text: 'Lahore Showroom: Main Bazar Chandni Chowk, Sanda Kalan, Lahore',
    },
    {
        icon: Clock,
        text: 'Showroom Timings: Monday to Saturday 10:00 AM to 9:00 PM | Helpline: 04237145264',
    },
    {
        icon: ShieldCheck,
        text: '100% Genuine Box-Packed Appliances with Official Brand Warranties',
    },
    {
        icon: Award,
        text: 'Serving Trusted Homes & Families Across Lahore Since 1980',
    },
    {
        icon: CheckCircle2,
        text: 'Order Verification on Call by Sales Specialist Before Dispatch in Lahore',
    },
    {
        icon: PhoneCall,
        text: 'Helpline: 04237145264 | WhatsApp: 0327-8859655 (10:00 AM to 9:00 PM)',
    },
];

export const TopMarqueeStrip = () => {
    return (
        <div
            className="top-marquee-strip"
            aria-label="Official Store Announcements"
        >
            {/* Animated Premium Glass Light Shine Sweep */}
            <div className="top-marquee-shine-overlay" aria-hidden="true" />

            <div className="top-marquee-viewport">
                <div className="top-marquee-track">
                    {[1, 2].map((repeatIdx) => (
                        <div
                            key={repeatIdx}
                            aria-hidden={repeatIdx === 2 ? 'true' : undefined}
                            className="top-marquee-group"
                        >
                            {TOP_MARQUEE_ITEMS.map((item, idx) => {
                                const Icon = item.icon;
                                return (
                                    <div key={idx} className="top-marquee-item">
                                        <Icon className="top-marquee-icon" size={13} />
                                        <span>{item.text}</span>
                                        <span className="top-marquee-diamond" aria-hidden="true">✦</span>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TopMarqueeStrip;
